<template>
 <span>
     <s-button 
                @onclick="open=true"
                label="Gagner des crédits gratuit en visualisant des vidéos"
                theme="is-success is-large"
                icon="film"
                v-if="!open && videos.length>0"
                mode="V"
            />
           
    <s-modal
        :open="open"
        :close="true"
        @close="open=false"
        title="Choisissez une vidéo et gagner un crédit gratuit"
    >
        <div v-for="video in videos" style="font-size: 20px;height: 50px;width: 100%">
            <div style="margin-left:5px;display:inline-block"> {{video.title}}  </div>
            
            <div style="float:right;display:inline-block">
                <s-button label="" icon="play" theme="is-success" @onclick="readVideo(video)"/>
            </div>
            <hr/>
        </div>
        <div v-if="videos.length==0">
            <s-l id="allvideosRead">Vous avez vu toutes les vidéos</s-l>
        </div>
       
        <s-you-tube 
            v-if="idVideo!=null" 
            id="video_home" 
            :sendCredit="true"
            :videoIdParam="videoIdElement"
            theme="is-danger" 
            label="Découvrez en vidéo" 
            :init="true"
            @close="idVideo=null"
            @sendCredit="sendCredit"/>
    </s-modal>
 </span>
</template>
<script>
import firebase_api from "@/firebase/firebase_api"
import firebase from 'firebase'
import mail_fct from "@/firebase/mails"
export default {
    data() {
        return {
            videos: [],
            idVideo: null,
            videoIdElement: null,
            open: false
        }
    },
    watch: {
       open: function(val) {
            if (val)
                this.refresh();
        },
    },
    mounted() {
        this.refresh();
    },
    methods: {
        readVideo (videoAtt) {
            
            this.idVideo = videoAtt.key;
            this.videoIdElement = videoAtt.id;
        },
        sendCredit() {
            var user = this.$store.getters.getUser;
            const functions = firebase.app().functions('europe-west1');
            const params =  {
                type: "FILM",
                credit: 1,
                email: user.email,
                url: window.location
            }
            if (typeof(user.videosCredit)=="undefined") {
                    user.videosCredit = [];
            }   
            user.videosCredit.push(this.videoIdElement);
                firebase_api.api.getDb().collection("user").doc(user.email).set(user).then(res=>{
                    this.refresh();
                });
            functions.httpsCallable("sendCredit")(params).then(res=>{
                var paramsMail= {
                    credit: 1,
                    displayName: user.displayName,
                    url: window.location.origin 
                }
                mail_fct.object.sendEmail(user.email, "SEND_OFFRE_CREDIT", paramsMail);
                this.$emit("sendCredit");
                
                // on envoie le mail
                // on dit un message comme quoi c bon
                // il peut aller les voir dans l'historique
                // i lpeut les anneuler tant que ca n'a pas été pris
            })
        },
        refresh() {
           this.videos = [];
            firebase_api.api.getDb().collection("videos").doc("video_home").get().then(query=>{
                var dataVideo = query.data();
                
                if (typeof(dataVideo.videos)!="undefined") {
                    dataVideo.videos.forEach(videoItem=>{
                        if (typeof(videoItem.credit) != "undefined") {
                            if (videoItem.credit = "1") {
                                    var pushVideo = false;
                                    var user = this.$store.getters.getUser;
                                    if (typeof(user.videosCredit)=="undefined")
                                        pushVideo = true;
                                    else {                                        
                                        if (user.videosCredit.indexOf(videoItem.id) == -1) 
                                            pushVideo = true;
                                    }
                                    if (pushVideo) {
                                        videoItem.key = videoItem.id;
                                        this.videos.push(videoItem);
                                    }
                            }
                        }
                    })
                }
                
            
        })
        }
    }
    
}
</script>